export enum TalentProfileType {
  NurseProfile = 'NurseProfile',
  TechProfile = 'TechProfile',
}

export enum ScreenStatus {
  NOT_SCREENED = 'not_screened',
  SCHEDULED = 'scheduled',
  CONTACTED = 'contacted',
  PASSED = 'passed',
  FAILED = 'failed',
  REACTIVATED_NOT_SCREENED = 'reactivated_not_screened',
}

export enum ScreenType {
  SCREENER = 'screener',
  AUTOMATED = 'automated',
  REACTIVATION_FORM = 'reactivation_form',
}
